import { FALLBACK_ARCADE_IMAGE } from '../../assets';

export function getBaseUrl( isUmbrella ) {
  if ( isUmbrella && window.location.hostname === 'localhost' ) {
    return 'https://qa.recognition-now.io/api';
  }

  if ( isUmbrella ) {
    return `https://${ window.location.hostname }/api`;
  }

  return '';
}

export function getUmbrellaImageUrl( url, isUmbrella, fallback = FALLBACK_ARCADE_IMAGE ) {
  if ( !isUmbrella ) { return url || fallback; }

  if ( !url ) { return fallback; }

  try {
    const pathname = url.startsWith( 'http://' ) || url.startsWith( 'https://' )
      ? new URL( url ).pathname
      : ( url.startsWith( '/' ) ? url : `/${ url }` );
    return `${ getBaseUrl( isUmbrella ) }${ pathname }`;
    
  } catch {
    return fallback;
  }
}
